module.exports = __webpack_public_path__ + "img/about-ceo.18de0ae9.png";